import { graphql } from '@/gql';
import type { HomeServiceOrderChargeInputType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderCharge } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderChargeFragment';

export const chargeHomeServiceOrder = async (data: HomeServiceOrderChargeInputType) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation ChargeHomeServiceOrder($data: HomeServiceOrderChargeInputType!) {
        chargeHomeServiceOrder(data: $data) {
          ...HomeServiceOrderChargeFragment
        }
      }
    `),
  });

  return response.data?.chargeHomeServiceOrder as HomeServiceOrderCharge;
};
